<template>
	<div>
		<a
			href="javascript:void(0)"
			class="disclosure-link"
			@click="scrollToContainer"
		>Read important investment disclosures</a>
	</div>
</template>

<script>
export default {
	name: 'ReadMoreLink',
	props: {
		useAlternateContainer: Boolean
	},
	methods: {
		scrollToContainer() {
			const header = document.getElementById('sticky-header');
			const section = this.useAlternateContainer
				? document.querySelector('.hedge')
				: document.getElementById('disclosure'); // this is the id that matches the disclosures div in the integrated site
			let scrollToSpot;
			let headerStuck;
			if (header) {
				const headerHeight = header.offsetHeight;
				headerStuck = header.classList.contains('sticky');
				if (headerStuck || window.innerWidth > 768) {
					scrollToSpot = section.offsetTop - headerHeight - 10;
				} else {
					scrollToSpot = section.offsetTop - 10;
				}
			} else {
				scrollToSpot = section.offsetTop - 10;
			}
			const zero = 0;
			const modal = document.getElementById('modal-scroll-element');
			const isInternetExplorer =
				/*cc_on!@*/ false || !!document.documentMode;
			const isSafari =
				Object.prototype.toString
					.call(window.HTMLElement)
					.indexOf('Constructor') >= 0;
			if (modal) {
				// The first condition checks if IE is being used.
				if (isInternetExplorer || isSafari) {
					modal.scrollTop = scrollToSpot;
				} else {
					modal.scrollTo({
						top: scrollToSpot,
						left: 0,
						behavior: 'smooth'
					});
				}
			} else {
				if (isInternetExplorer || isSafari) {
					window.scrollTo(zero, scrollToSpot);
				} else {
					window.scrollTo({
						top: scrollToSpot,
						left: 0,
						behavior: 'smooth'
					});
				}
			}
		}
	}
};
</script>

<style lang="css" scoped>
.disclosure-link {
	color: #1d5799;
	font-family: Avenir Next LT W01 Demi, Arial, sans-serif;
	font-size: 14px;
	font-weight: 700;
	margin-bottom: 13px;
}
</style>
